import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../contexts/user.context";
import { Delete, Get, handleError } from "../../../utils/fetch.util";
import { toast } from "react-toastify";
import i18next, { t } from "i18next";
import AddEditSalaryRecord from "../../../components/modals/AddEditSalaryRecord/AddEditSalaryRecord.component";
import NoData from "../../../components/noData/noData.component";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import ConfirmationModal from "../../../components/modals/confirmationModal/confirmationModal.component";
import { useCommanData } from "../../../contexts/commanData.context";
import LoadingData from "../../../components/loadingData/loadingData.component";
import Image from "../../../components/Image/Image.component";
import ReactPaginate from "react-paginate";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";

const SalaryRecord = () => {
  const [salaryRecords, setSalaryRecords] = useState<any[]>([]);
  const { getValidToken } = useContext(UserContext);
  const [openAddSalaryRecord, setOpenAddSalaryRecord] =
    useState<boolean>(false);
  const [editSalaryRecord, setEditSalaryRecord] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [salaryRecordId, setSalaryRecordId] = useState<number>(0);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const [month, setMonth] = useState<string>(new Date().toISOString().split("T")[0].slice(0, 7));
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    count: 0,
  });
  const { setRecycleBin } = useCommanData();


  const getAllSalaryRecords = async () => {
    setIsLoading(true);
    const query: any[] = [];
    query.push(`page=${pagination.page}`);
    query.push(`pageItemsCount=${pagination.limit}`);
    if (search.length > 0) query.push(`search=${search}`);
    if (month.length > 0) query.push(`month=${month.split("-")[1]}`);

    const res = await Get(
      `staff-salary/get-all-salary-records?${query.join("&")}`,
      getValidToken()
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    setSalaryRecords(res.data);
    setPagination({
      ...pagination,
      count: res.count,
    });
  };

  const deleteSalaryRecord = async () => {
    const res = await Delete(
      `staff-salary/delete-salary-record?salary_record_id=${salaryRecordId}`,
      getValidToken()
    );

    if (res.error || !res.data) {
      handleError(res);
      return;
    }
    toast.success("Successfully Deleted");
    getAllSalaryRecords();
  };

  useEffect(() => {
    getAllSalaryRecords();
  }, [pagination.page, search, month]);

  useEffect(() => {
    setRecycleBin("deleted-salary-record");

    return () => {
      setRecycleBin("");
    };
  }, []);

  if (isLoading) return <LoadingData />;

  return (
    <>
      <div className="container bg-white p-6 px-8">
        <div className="flex items-center justify-between my-5">
          <h1 className="text-5xl">
            {t("salary_records")}
            <span className="text-2xl">({pagination.count})</span>
          </h1>

          <div className="flex items-center gap-2">
            <button
              className="main_btn"
              onClick={() => setOpenAddSalaryRecord(true)}
            >
              {t("add_salary_record")}
            </button>
            <input type="month" className="border p-2 rounded-xl" value={month} onChange={(e) => setMonth(e.target.value)} />
            <input type="search" className="border p-2 rounded-xl" placeholder={t("search")} value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
        </div>
        {salaryRecords?.length === 0 ? (
          <div className="flex justify-center items-center h-[500px]">
            <NoData message={t("no_salary_records")} />
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full mt-5 mb-5">
                <thead className="w-full">
                  <tr className="border-collapse border-2 w-full">
                    <th
                      className={`border-collapse border-2 p-3 min-w-[80px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("id")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[80px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("name")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[80px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("phone")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[80px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("net_salary")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[80px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("total_with_fees")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[80px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("deduction")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[80px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("bonus")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[80px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("month")}
                    </th>

                    <th
                      className={`border-collapse border-2 p-3 min-w-[80px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("actions")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="h-6">
                    <td className=""></td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className=""></td>
                  </tr>
                  {salaryRecords.length > 0 &&
                    salaryRecords.map((item, i) => {
                        return (
                        <tr>
                          <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          {item.id}
                          </td>
                          <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          <div className="flex items-center gap-3">
                            <Image
                            src={item?.staff?.asdc_client_profile_pic_url}
                            key={i}
                            alt={
                              item?.staff?.asdc_client_staff_name +
                              "Profile Picture"
                            }
                            className="rounded-full duration-500 cursor-pointer inline-block w-10 h-10 hover:translate-y-[-5px]"
                            />
                            <span>{item?.staff?.asdc_client_staff_name}</span>
                          </div>
                          </td>
                          <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          {item?.staff?.asdc_client_staff_phone}
                          </td>
                          <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          {item.netSalary}
                          </td>
                          <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          {item.totalWithFees}
                          </td>
                          <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          {item.deduction}
                          </td>
                          <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          {item.bonus}
                          </td>
                          <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          {item.month}
                          </td>

                          <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          <div className="flex gap-2">
                            <button
                            className=""
                            onClick={() => {
                              setEditSalaryRecord(item);
                              setOpenAddSalaryRecord(true);
                            }}
                            >
                            <FiEdit className="text-xl text-text cursor-pointer" />
                            </button>

                            <button
                            className="text-red-500 cursor-pointer"
                            onClick={() => {
                              setIsConfirmationModalOpen(true);
                              setSalaryRecordId(item.id);
                            }}
                            >
                            <RiDeleteBinLine className="text-[1.40rem] text-red-500 cursor-pointer" />
                            </button>
                          </div>
                          </td>
                        </tr>
                        );
                      })}
                    </tbody>
                    </table>
                  </div>
                  {pagination.limit ? (
                    <ReactPaginate
                    className="pagination_table"
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    pageClassName={"page-item"}
                    forcePage={pagination.page - 1}
                    onPageChange={(event: any) =>
                      setPagination({ ...pagination, page: event.selected + 1 })
                    }
                    breakLabel="..."
                    pageCount={Math.ceil(pagination.count / pagination.limit)}
                    previousLabel={
                      pagination.page == 1 ? null : (
                      <div
                        style={{
                        backgroundColor: "#B8C1CC",
                        width: "36px",
                        height: "36px",
                        }}
                        className="flex items-center justify-center rounded-full text-white"
                      >
                        <GrFormPrevious size={28} />
                      </div>
                      )
                    }
                    nextLabel={
                      pagination.page ==
                      Math.ceil(pagination.count / pagination.limit) ? null : (
                      <div
                        style={{
                        backgroundColor: "#B8C1CC",
                        width: "36px",
                        height: "36px",
                        }}
                        className="flex items-center justify-center rounded-full text-white"
                      >
                        <GrFormNext size={28} />
                      </div>
                      )
                    }
                    />
                  ) : (
                    ""
                  )}
                  </>
                )}
      </div>
      <AddEditSalaryRecord
        open={openAddSalaryRecord}
        setOpen={setOpenAddSalaryRecord}
        editSalaryRecord={editSalaryRecord}
        setEditSalaryRecord={setEditSalaryRecord}
        getAllItems={getAllSalaryRecords}
      />
      <ConfirmationModal
        title={t("delete_salary_record")}
        message={t("confirm_delete")}
        isLoading={isLoading}
        onConfirm={() => {
          deleteSalaryRecord();
          setIsConfirmationModalOpen(false);
        }}
        closeConfirmationModal={() => setIsConfirmationModalOpen(false)}
        isShown={isConfirmationModalOpen}
        strict={true}
      />
    </>
  );
};

export default SalaryRecord;
